export default {
  signup: {
    pageTitle: 'Sign up',
    register: 'Create an Account',
    signupWithGithub: 'Sign up with GitHub',
    processingRegistration: 'Processing registration'
  }
}
